import React, { useEffect } from 'react';
import { Button, Col, Form, Input, Row, Card, Space, Typography } from 'antd';
import { 
	FacebookOutlined, EditOutlined, InstagramOutlined, MailOutlined, 
	MobileOutlined, YoutubeOutlined, UserOutlined, CameraOutlined,
	LinkOutlined
} from '@ant-design/icons';
import { SERVER_IP } from 'assets/Config';
import FileUpload from 'components/file-upload/file-upload';
import { useDispatch, useSelector } from 'react-redux';
import { putApi } from 'redux/sagas/putApiSaga';
import { resetApiStatus, resetApiResponse } from 'redux/reducers/globals/globalActions';
import { useI18n } from 'hooks/useI18n';

const { Title, Text } = Typography;

// const beforeUpload = (file) => {
// 	const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
// 	if (!isJpgOrPng) {
// 		message.error('You can only upload JPG/PNG file!');
// 	}
// 	const isLt2M = file.size / 1024 / 1024 < 2;
// 	if (!isLt2M) {
// 		message.error('Image must smaller than 2MB!');
// 	}
// 	return isJpgOrPng && isLt2M;
// };

export const IMAGE_URL = SERVER_IP + '';

const ProfilePresentational = ({ userDetails, fileList, onChange, onPreview }) => {
	const [loading] = React.useState(false);
	const { t } = useI18n();
	const [isEditSocial, setIsEditSocial] = React.useState(false);
	const [isDragOver, setIsDragOver] = React.useState(false);
	const [uploadError, setUploadError] = React.useState(null);
	// const [, setBannerLoading] = React.useState(false);
	// const [imageUrl, setImageUrl] = React.useState();
	// const [bannerImageUrl, setBannerImageUrl] = React.useState();
	// const IMAGE_ACTION_URL = SERVER_IP + 'api/media/upload';
	const loginRedux = useSelector((state) => state.loginRedux);
	const globalRedux = useSelector((state) => state.globalRedux);
	const [profilePicList, setProfilePicList] = React.useState([]);
	const [bannerList, setBannerList] = React.useState([]);
	const dispatch = useDispatch();
	const [form] = Form.useForm();

	// const handleChange = (info, type = 'profile') => {
	// 	if (info.file.status === 'uploading') {
	// 		type === 'profile' ? setLoading(true) : setBannerLoading(true);
	// 		return;
	// 	}
	// 	if (info.file.status === 'done') {
	// 		// Get this url from response in real world.
	// 		getBase64(info.file.originFileObj, (url) => {
	// 			if (type === 'profile') {
	// 				setLoading(false);
	// 				setImageUrl(url);
	// 				// dispatch(postApi(data, 'PROFILE_IMAGE_UPDATE'));
	// 			} else {
	// 				setBannerLoading(false);
	// 				setBannerImageUrl(url);
	// 			}
	// 		});
	// 	}
	// };
	// const uploadButton = (
	// 	<div>
	// 		{loading ? <LoadingOutlined /> : <UploadOutlined />}
	// 		<div style={{ marginTop: 8 }}>Upload</div>
	// 	</div>
	// );

	// const updateProfilePic = async () => {
	// 	if (loginRedux.profilePic !== profilePicList[0].url) {
	// 		const data = {
	// 			profilePic: profilePicList[0].thumbUrl,
	// 		};
	// 		let url = `${SERVER_IP}api/users/${loginRedux.id}`;
	// 		dispatch(putApi(data, 'EDIT_CUSTOMER', url));
	// 	}
	// };

	useEffect(() => {
		const updatebannerPic = async () => {
			if (bannerList.length > 0 && bannerList[0]) {
				const fileObj = bannerList[0];
				console.log('Checking banner pic for upload:', fileObj);
				
				// Check if this is a new file (has originFileObj) or a cropped file
				const fileToUpload = fileObj.originFileObj || fileObj;
				
				// Only proceed if we have a file and it's not just a URL from server
				if (fileToUpload && fileToUpload instanceof File) {
					console.log('Updating banner pic with file:', fileToUpload);
					const formData = new FormData();
					formData.append('bannerImage', fileToUpload);
					console.log('FormData contents:', formData.get('bannerImage'));

					let url = `${SERVER_IP}api/users/${loginRedux.id}`;
					dispatch(putApi(formData, 'EDIT_CUSTOMER', url, true)); // true indicates it's FormData
				} else {
					console.log('No valid file to upload or file is from server');
				}
			}
		};
		
		// Check if we have a new file to upload
		if (bannerList.length > 0 && bannerList[0]) {
			const fileObj = bannerList[0];
			const hasNewFile = (fileObj.originFileObj instanceof File) || (fileObj instanceof File);
			
			if (hasNewFile) {
				console.log('New banner pic detected, triggering upload');
				updatebannerPic();
			}
		}
	}, [bannerList, dispatch, loginRedux]);

	useEffect(() => {
		const updateProfilePic = async () => {
			if (profilePicList.length > 0 && profilePicList[0]) {
				const fileObj = profilePicList[0];
				console.log('Checking profile pic for upload:', fileObj);
				
				// Check if this is a new file (has originFileObj) or a cropped file
				const fileToUpload = fileObj.originFileObj || fileObj;
				
				// Only proceed if we have a file and it's not just a URL from server
				if (fileToUpload && fileToUpload instanceof File) {
					console.log('Updating profile pic with file:', fileToUpload);
					const formData = new FormData();
					formData.append('profilePic', fileToUpload);
					console.log('FormData contents:', formData.get('profilePic'));

					let url = `${SERVER_IP}api/users/${loginRedux.id}`;
					dispatch(putApi(formData, 'EDIT_CUSTOMER', url, true)); // true indicates it's FormData
				} else {
					console.log('No valid file to upload or file is from server');
				}
			}
		};
		
		// Check if we have a new file to upload
		if (profilePicList.length > 0 && profilePicList[0]) {
			const fileObj = profilePicList[0];
			const hasNewFile = (fileObj.originFileObj instanceof File) || (fileObj instanceof File);
			
			if (hasNewFile) {
				console.log('New profile pic detected, triggering upload');
				updateProfilePic();
			}
		}
	}, [profilePicList, dispatch, loginRedux]);

	console.log("🚀 ~ ProfilePresentational ~ userDetails:", userDetails?.profilePic, userDetails?.bannerImage)
	console.log("🚀 ~ ProfilePresentational ~ SERVER_IP:", SERVER_IP)
	console.log("🚀 ~ ProfilePresentational ~ loginRedux:", loginRedux)
	console.log("🚀 ~ ProfilePresentational ~ profilePicList:", profilePicList)
	console.log("🚀 ~ ProfilePresentational ~ bannerList:", bannerList)
	
	useEffect(() => {
		console.log('🚀 ~ useEffect ~ userDetails changed:', userDetails);
		
		if (userDetails?.profilePic) {
			console.log('Setting initial profile pic from userDetails:', userDetails.profilePic);
			const profilePicUrl = userDetails.profilePic.startsWith('http') 
				? userDetails.profilePic 
				: SERVER_IP + userDetails.profilePic;
			
			console.log('🚀 ~ Profile pic URL:', profilePicUrl);
			
			setProfilePicList([
				{
					uid: userDetails?.profilePic,
					name: userDetails?.firstName + ' ' + userDetails?.lastName,
					url: profilePicUrl,
					thumbUrl: profilePicUrl,
					status: 'done',
				},
			]);
		} else {
			console.log('No profile pic found in userDetails');
			setProfilePicList([]);
		}
		
		if (userDetails?.bannerImage) {
			const bannerUrl = userDetails.bannerImage.startsWith('http') 
				? userDetails.bannerImage 
				: SERVER_IP + userDetails.bannerImage;
			
			setBannerList([
				{
					uid: userDetails?.bannerImage,
					name: userDetails?.firstName + ' ' + userDetails?.lastName,
					url: bannerUrl,
					thumbUrl: bannerUrl,
					status: 'done',
				},
			]);
		} else {
			console.log('No banner image found in userDetails');
			setBannerList([]);
		}
	}, [userDetails]);

	// Debug effect to track profile pic list changes
	useEffect(() => {
		console.log('🔄 Profile pic list changed:', profilePicList);
	}, [profilePicList]);

	// Debug effect to track API status changes
	useEffect(() => {
		console.log('🔄 API Status changed:', globalRedux.apiStatus);
		if (globalRedux.apiStatus.EDIT_CUSTOMER === 'PENDING') {
			console.log('✅ Upload API call started...');
		} else if (globalRedux.apiStatus.EDIT_CUSTOMER === 'SUCCESS') {
			console.log('✅ Upload API call successful!');
		} else if (globalRedux.apiStatus.EDIT_CUSTOMER === 'FAILED') {
			console.log('❌ Upload API call failed!');
		}
	}, [globalRedux.apiStatus]);

	console.log('🚀 ~ ProfilePresentational ~ userDetails:', bannerList);

	console.log('Banner URL:', bannerList[0]?.url);

	const onSocialEditClick = () => {
		setIsEditSocial(!isEditSocial)
	}

	const onUpdateSocialLinks = (values) => {
		const sData = {
			socialLinks: values,
		};
		let url = `${SERVER_IP}api/users/${loginRedux.id}`;
		dispatch(putApi(sData, 'EDIT_USER', url));
	}

	useEffect(() => {
		if (globalRedux.apiStatus.EDIT_USER === 'SUCCESS') {
			dispatch(resetApiStatus('EDIT_USER'));
			form?.resetFields();
			setIsEditSocial(false);
		}
	}, [dispatch, form, globalRedux.apiStatus.EDIT_USER]);

	useEffect(() => {
		if (globalRedux.apiStatus.EDIT_CUSTOMER === 'SUCCESS') {
			const response = globalRedux.apiResponse?.EDIT_CUSTOMER;
			if (response?.profilePic) {
				setProfilePicList([{
					...profilePicList[0],
					url: SERVER_IP + response.profilePic,
					thumbUrl: SERVER_IP + response.profilePic,
				}]);
			}
			if (response?.bannerImage) {
				setBannerList([{
					...bannerList[0],
					url: SERVER_IP + response.bannerImage,
					thumbUrl: SERVER_IP + response.bannerImage,
				}]);
			}
			dispatch(resetApiStatus('EDIT_CUSTOMER'));
			dispatch(resetApiResponse('EDIT_CUSTOMER'));
		}
	}, [dispatch, globalRedux.apiStatus.EDIT_CUSTOMER, globalRedux.apiResponse?.EDIT_CUSTOMER, profilePicList, bannerList]);

	const onEditCancel = () => {
		form.resetFields();
		setIsEditSocial(false);
	};

	// Error handler for file uploads
	const handleUploadError = (error) => {
		setUploadError(error);
		console.error('Upload error:', error);
		// Clear error after 5 seconds
		setTimeout(() => setUploadError(null), 5000);
	};

	// Helper function to upload profile picture
	const uploadProfilePicture = (file) => {
		console.log('uploadProfilePicture called with:', file);
		if (file instanceof File) {
			console.log('Uploading profile picture file:', file.name, file.size, file.type);
			const formData = new FormData();
			formData.append('profilePic', file);
			let url = `${SERVER_IP}api/users/${loginRedux.id}`;
			console.log('API URL:', url);
			dispatch(putApi(formData, 'EDIT_CUSTOMER', url, true));
			return true;
		} else {
			console.log('File is not a valid File instance:', file);
			return false;
		}
	};

	// Helper function to upload banner image
	const uploadBannerImage = (file) => {
		console.log('uploadBannerImage called with:', file);
		if (file instanceof File) {
			console.log('Uploading banner image file:', file.name, file.size, file.type);
			const formData = new FormData();
			formData.append('bannerImage', file);
			let url = `${SERVER_IP}api/users/${loginRedux.id}`;
			console.log('API URL:', url);
			dispatch(putApi(formData, 'EDIT_CUSTOMER', url, true));
			return true;
		} else {
			console.log('File is not a valid File instance:', file);
			return false;
		}
	};

	// Drag and drop handlers for banner
	const handleDragOver = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragOver(true);
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		e.stopPropagation();
		// Only set drag over to false if we're leaving the banner area completely
		if (!e.currentTarget.contains(e.relatedTarget)) {
			setIsDragOver(false);
		}
	};

	const handleDrop = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragOver(false);

		const files = Array.from(e.dataTransfer.files);
		console.log('Files dropped:', files);
		
		if (files.length > 0) {
			const file = files[0];
			
			// Check if it's an image
			if (file.type.startsWith('image/')) {
				console.log('Valid image file dropped:', file.type, file.size);
				// Create a file object with the required properties
				const fileObject = {
					uid: `${Date.now()}-${file.name}`,
					name: file.name,
					status: 'done',
					originFileObj: file,
					thumbUrl: URL.createObjectURL(file),
				};
				
				console.log('Setting banner with dropped file:', fileObject);
				setBannerList([fileObject]);
			} else {
				handleUploadError('Please drop an image file');
				console.warn('Invalid file type dropped:', file.type);
			}
		}
	};

	const handleDragEnter = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};

	// Handle banner file change
	const handleBannerChange = (info) => {
		console.log('Banner change triggered:', info);
		console.log('Banner file info:', info.file);
		console.log('Banner file status:', info.file?.status);
		
		if (info.fileList && info.fileList.length > 0) {
			setBannerList(info.fileList);
			
			// Manual trigger for upload if file is ready
			if (info.file && info.file.status === 'done') {
				console.log('Banner file is ready, attempting upload...');
				const fileToUpload = info.file.originFileObj || info.file;
				setTimeout(() => {
					uploadBannerImage(fileToUpload);
				}, 100);
			}
		} else {
			setBannerList([]);
		}
	};

	// Handle logo file change
	const handleLogoChange = (info) => {
		console.log('Logo change triggered:', info);
		console.log('File info:', info.file);
		console.log('File list:', info.fileList);
		console.log('File status:', info.file?.status);
		console.log('File originFileObj:', info.file?.originFileObj);
		console.log('Is file instance of File?', info.file instanceof File);
		console.log('Is originFileObj instance of File?', info.file?.originFileObj instanceof File);
		
		// Always update the profile picture list with the latest fileList
		setProfilePicList(info.fileList);
		
		// Manual trigger for upload if file is ready
		if (info.file && info.file.status === 'done') {
			console.log('File is ready, attempting upload...');
			const fileToUpload = info.file.originFileObj || info.file;
			setTimeout(() => {
				uploadProfilePicture(fileToUpload);
			}, 100);
		}
	};

	// Direct click handler for banner area
	const handleBannerClick = (e) => {
		// Only trigger if clicking on the banner background, not the profile pic
		if (e.target === e.currentTarget || e.target.closest('.banner-upload-text')) {
			const fileInput = document.querySelector('.banner-upload-overlay input[type="file"]');
			if (fileInput) {
				fileInput.click();
			}
		}
	};

	const socialItems = [
		userDetails?.socialLinks?.facebook
			? { key: 'facebook', href: userDetails.socialLinks.facebook, icon: <FacebookOutlined />, label: t('profile.social.facebook'), className: 'facebook' }
			: null,
		userDetails?.socialLinks?.instagram
			? { key: 'instagram', href: userDetails.socialLinks.instagram, icon: <InstagramOutlined />, label: t('profile.social.instagram'), className: 'instagram' }
			: null,
		userDetails?.socialLinks?.youtube
			? { key: 'youtube', href: userDetails.socialLinks.youtube, icon: <YoutubeOutlined />, label: t('profile.social.youtube'), className: 'youtube' }
			: null,
	].filter(Boolean);

	const hasSocialLinks = socialItems.length > 0;

	return (
		<div className="profileContainer">
			{/* Error Display */}
			{uploadError && (
				<div style={{
					position: 'fixed',
					top: '20px',
					right: '20px',
					background: '#ff4d4f',
					color: 'white',
					padding: '12px 16px',
					borderRadius: '8px',
					zIndex: 9999,
					boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
				}}>
					{uploadError}
				</div>
			)}

			{/* Professional Header Section */}
			<div className="profile-header">
				{/* <div 
					className={`banner ${(bannerList[0]?.url || bannerList[0]?.thumbUrl) ? 'has-banner-image' : ''} ${isDragOver ? 'drag-over' : ''}`} 
					style={{
						height: '200px',
						...((bannerList[0]?.url || bannerList[0]?.thumbUrl) && {
							backgroundImage: bannerList[0]?.thumbUrl ? `url(${bannerList[0]?.thumbUrl})` : `url(${bannerList[0]?.url})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat',
						}),
					}}
					onDragOver={handleDragOver}
					onDragLeave={handleDragLeave}
					onDrop={handleDrop}
					onDragEnter={handleDragEnter}
					onClick={handleBannerClick}
				>
					<div className="banner-upload-overlay" style={{ background: (bannerList[0]?.url || bannerList[0]?.thumbUrl) ? 'transparent' : undefined }}>
						<FileUpload
							aspect={16 / 9}
							className="banner-uploader"
							listType="picture-card"
							setFileList={setBannerList}
							action={'/'}
							fileList={bannerList}
							max={1}
							onChange={handleBannerChange}
							uploadText=""
							showUploadList={false}
							accept="image/*"
							onError={handleUploadError}
						/>
					</div>

					{!(bannerList[0]?.url || bannerList[0]?.thumbUrl) && (
						<div className="banner-upload-text">
							<div className="upload-icon-wrapper">
								<CameraOutlined className="upload-icon" />
								{isDragOver && <div className="drag-indicator">Drop image here</div>}
							</div>
							<div className="upload-main-text">
								{isDragOver ? t('profile.upload.drop_to_upload') : t('profile.upload.add_cover')}
							</div>
							<div className="upload-sub-text">
								{isDragOver ? t('profile.upload.release_to_upload') : t('profile.upload.click_browse')}
							</div>
							<div className="drag-text">{t('profile.upload.supports_files')}</div>
						</div>
					)}

					{(bannerList[0]?.url || bannerList[0]?.thumbUrl) && (
						<div className="change-banner-text">
							<EditOutlined className="change-icon" />
							<div className="change-text">
								{isDragOver ? t('profile.upload.drop_to_replace') : t('profile.upload.change_cover')}
							</div>
							{isDragOver && <div className="drop-hint">{t('profile.upload.release_to_update')}</div>}
						</div>
					)}
					
					<div className={`profileIcon ${profilePicList.length > 0 ? 'has-image' : ''}`}>
							<FileUpload
							className="avatar-uploader"
							listType="picture-circle"
							action={'/'}
							setFileList={setProfilePicList}
							fileList={profilePicList}
							max={1}
							onChange={handleLogoChange}
								uploadText={profilePicList.length > 0 ? t('profile.upload.change_logo') : t('profile.upload.upload_logo')}
							accept="image/*"
							showUploadList={true}
							onError={handleUploadError}
							key={`profile-upload-${Date.now()}`}
							aspect={1}
						/>
						
						{(profilePicList.length > 0 && (profilePicList[0]?.url || profilePicList[0]?.thumbUrl)) && (
							<div className="profile-change-overlay" onClick={() => {
								console.log('Profile change overlay clicked - triggering file input');
								const fileInput = document.querySelector('.avatar-uploader input[type="file"]');
								if (fileInput) {
									fileInput.click();
								}
							}}>
								<EditOutlined />
								<span>{t('profile.change')}</span>
							</div>
						)}
					</div>
				</div> */}

				<div className="profile-info">
					<div className="profile-hero-grid">
						<div className="main-info">
							<div className="profile-kicker">{t('navigation.profile')}</div>
							<h1 className="gym-name">{userDetails?.gymName || t('profile.gym_name')}</h1>
							<div className="owner-pill">
								<UserOutlined />
								<span>{userDetails?.firstName} {userDetails?.lastName}</span>
							</div>
							<p className="description">{userDetails?.description || t('profile.description_placeholder')}</p>
							<div className="action-buttons">
								<Button className="save-btn">{t('profile.saved_automatically')}</Button>
							</div>
						</div>

						<div className="profile-side-panels">
							<div className="info-panel contact-section">
								<div className="section-title">{t('profile.contact_information')}</div>
								<div className="contact-item">
									<MailOutlined />
									<div>
										<span className="contact-item__label">Email</span>
										<strong>{userDetails?.email || '-'}</strong>
									</div>
								</div>
								<div className="contact-item">
									<MobileOutlined />
									<div>
										<span className="contact-item__label">Phone</span>
										<strong>{userDetails?.mobile || t('header.no_mobile')}</strong>
									</div>
								</div>
							</div>

							<div className="info-panel social-section">
								<div className="social-section__header">
									<div className="section-title">{t('profile.social_links')}</div>
									<Button className="social-link edit" onClick={onSocialEditClick}>
										<EditOutlined />
										<span>{t('profile.edit_links')}</span>
									</Button>
								</div>
								<div className="social-links">
									{hasSocialLinks ? socialItems.map((socialItem) => (
										<a key={socialItem.key} href={socialItem.href} target="_blank" rel="noreferrer" className={`social-link ${socialItem.className}`}>
											{socialItem.icon}
											<span>{socialItem.label}</span>
										</a>
									)) : (
										<div className="social-empty-state">{t('profile.description_placeholder')}</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Content Section */}
			<div className="profile-content">
				{isEditSocial && (
					<Card className="social-edit-card">
						<div className="card-header">
							<LinkOutlined />
							<Title level={4} className="card-title">{t('profile.edit_social_title')}</Title>
						</div>
						
						<Form
							form={form}
							layout="vertical"
							onFinish={onUpdateSocialLinks}
							className="social-form"
							initialValues={{
								facebook: userDetails?.socialLinks?.facebook,
								instagram: userDetails?.socialLinks?.instagram,
								youtube: userDetails?.socialLinks?.youtube,
							}}
						>
							<Form.Item
								label={t('profile.form.facebook_label')}
								name="facebook"
								rules={[
									{ type: 'url', message: t('forms.invalid_url') }
								]}
							>
								<Input 
									placeholder={t('profile.placeholders.facebook')} 
									prefix={<FacebookOutlined style={{ color: '#1877f2' }} />}
								/>
							</Form.Item>

							<Form.Item
								label={t('profile.form.instagram_label')}
								name="instagram"
								rules={[
									{ type: 'url', message: t('forms.invalid_url') }
								]}
							>
								<Input 
									placeholder={t('profile.placeholders.instagram')} 
									prefix={<InstagramOutlined style={{ color: '#e4405f' }} />}
								/>
							</Form.Item>

							<Form.Item
								label={t('profile.form.youtube_label')}
								name="youtube"
								rules={[
									{ type: 'url', message: t('forms.invalid_url') }
								]}
							>
								<Input 
									placeholder={t('profile.placeholders.youtube')} 
									prefix={<YoutubeOutlined style={{ color: '#ff0000' }} />}
								/>
							</Form.Item>

							<div className="form-actions">
								<Button danger onClick={onEditCancel}>
									{t('common.cancel')}
								</Button>
								<Button type="primary" htmlType="submit" loading={loading}>
									{t('profile.update_social_links')}
								</Button>
							</div>
						</Form>
					</Card>
				)}
			</div>
		</div>
	);
};

export default ProfilePresentational;
